/*
https://splidejs.com/guides/getting-started/
*/

import Splide from '@splidejs/splide';

window.addEventListener("load", function () {
    const loader = document.querySelector(".rgny__loader");
    loader.className += " hidden"; // class "loader hidden"
});

document.addEventListener( 'DOMContentLoaded', function() {
    const slider = document.querySelector('.slider');
    if( slider ) {
        var splide = new Splide( '.slider' , {
            type: 'fade',
            speed: 1000,
            arrows: false,
            pagination: true,
            rewind: true,
            waitForTransition: false,
        });
        splide.mount();
    }

    const experience = document.querySelector('.experience-slide');
    if( experience ) {
        const experienceSlides = document.querySelectorAll('.experience-slide');
        experienceSlides.forEach(function(slide, index) {
            var splideInstance = new Splide( slide , {
                perPage: 3,
                perMove: 1,
                type: 'loop',
                speed: 1000,
                arrows: true,
                pagination: false,
                rewind: false,
                gap: '50px',
                clones: 4,
                padding: { left: '5rem', right: '5rem' },
                id: slide.id || undefined, // Use custom ID from the element if it exists, otherwise let Splide auto-generate
                breakpoints: {
                    768: {
                        perPage: 1,
                    },
                    1024: {
                        perPage: 2,
                    },
                    1100: {
                        perPage: 3,
                    },
                }
            });
            splideInstance.mount();
        });
    }

    const events = document.querySelector('.events-slide');
    if( events ) {
        var splide3 = new Splide( '.events-slide' , {
            perPage: 4,
            perMove: 1,
            // type: 'loop',
            speed: 1000,
            arrows: false,
            pagination: true,
            rewind: false,
            gap: '20px',
            clones: 4,
            padding: { left: '0rem', right: '0rem' },
            breakpoints: {
                768: {
                    perPage: 1,
                },
                1024: {
                    perPage: 2,
                },
                1100: {
                    perPage: 3,
                },
            }
        });
        splide3.mount();
    }

    const gallery = document.querySelector('.event-gallery');
    if( gallery ) {
        var splide4 = new Splide( '.event-gallery' , {
            perPage: 1,
            perMove: 1,
            type: 'fade',
            speed: 1000,
            arrows: true,
            pagination: false,
            rewind: true,
        });
        splide4.mount();
    }

    const reviews = document.querySelector('.reviews-slide');
    if( reviews ) {
        var splide5 = new Splide( '.reviews-slide' , {
            perPage: 1,
            perMove: 1,
            type: 'loop',
            speed: 1000,
            arrows: true,
            pagination: false,
            rewind: false,
        });
        splide5.mount();
    }

    if ((".wedding-gallery__slider").length) {
        var slidesliders = document.querySelectorAll('.splide.wedding-gallery__slider');
        for (var i = 0; i < slidesliders.length; i++) {
            var slideslider = new Splide(slidesliders[i], {
                perPage: 2.5,
                perMove: 1,
                type: 'loop',
                speed: 1000,
                arrows: true,
                pagination: false,
                rewind: false,
                gap: '20px',
                clones: 4,
                padding: { left: '0rem', right: '0rem' },
                breakpoints: {
                    768: {
                        perPage: 1,
                        gap: '0px',
                    },
                    1024: {
                        perPage: 1.5,
                    },
                    1100: {
                        perPage: 2.5,
                    },
                }
            });
            slideslider.mount()
        }
    }
});